module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "article-list-item",
    on: {
      "click": _vm.onClick
    }
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', {
    staticClass: "avatar",
    style: ({
      'background-image': ("url(" + (_vm.item.cover_images[0]) + ")")
    })
  })]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('span', {
    staticClass: "tag"
  }, [_vm._v(_vm._s(_vm.item.type))]), _vm._v(_vm._s(_vm.item.title))]), _vm._v(" "), _c('div', {
    staticClass: "desc"
  }, [_vm._v(_vm._s(_vm.item.summary || _vm.item.title))]), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_vm._v(_vm._s(_vm.timeDisplay(_vm.item.publish_time * 1000)))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0871a306!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ArticleListItem.vue
// module id = 230
// module chunks = 1